<template>
    <div class="trial-screen">
        <h2 class="title">
            Let's Make a Trade!
        </h2>

        <div class="descriptions">
            <p class="description">
                Every new subscription begins with a 14-day trial. However, if you want to jump right in, you can trade in your trial for 2 months' worth of savings on your first annual subscription. So, what'll it be?
            </p>
        </div>

        <div class="options">
            <button class="form-button is-purple" @click="() => onContinue({ trial: false })">
                Trade-In My Trial
            </button>
            <button class="form-button is-green" @click="() => onContinue({ trial: true })">
                Keep 14-Day Trial
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        onContinue: {
            required: true,
            type: Function,
        },
    },
};
</script>
<style scoped lang="scss">
    @use './TrialScreen.scss';
</style>
